import { RenamingAspect } from './renaming.aspect';

export type { RenamingMain } from './renaming.main.runtime';
export default RenamingAspect;
export { RenamingAspect };
